import { getNextEvent } from "core-integration/src/store/events/reducers";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { HelmetHead } from "../HelmetHead";
import SquadBase from "./SquadBase";
import { SquadSelectionScoreboard } from "./SquadSelectionScoreboard";

const SquadSelection = () => {
  const { t } = useTranslation("squad");

  return (
    <SquadBase
      scoreboard={<SquadSelectionScoreboard />}
      title={t("squadSelection", "Squad Selection")}
      headTags={
        <HelmetHead
          title={t(
            "metadata.title",
            "Select Fantasy Football Players | Fantasy Premier League",
          )}
          description={t(
            "metadata.description",
            "To select your first Fantasy Premier League squad after completing the registration process, visit the official website of the Premier League.",
          )}
        />
      }
      nextEvent={useSelector(getNextEvent)}
    />
  );
};

export default SquadSelection;
